import $ from 'jquery';
import Masonry from 'masonry-layout';
import ImagesLoaded from 'imagesloaded';

ImagesLoaded.makeJQueryPlugin($);

$(() => {
  $('.post-grid__grid').each((i, el) => {
    const msnry = new Masonry(el, {
      itemSelector: '.post-grid__item',
      columnWidth: '.post-grid__item'
    });

    $(el).data('masonry', msnry);

    $(el).imagesLoaded(() => {
      msnry.layout();
    });
  });
});
